import { DEFAULT_LANGUAGE, languages } from '../../configs/language'
import { EMPTY_VALUE, ZERO_IN_FINANCIAL_STATEMENT } from '../utils/common'
import { CURRENCY } from '../utils/currency'

export const formatVal = (
  val,
  locale = DEFAULT_LANGUAGE,
  isFinancialStatement = false,
  count = 2,
  formatValidVal = (val) => val,
) => {
  val = typeof val === 'string' ? parseFloat(parseFloat(val)) : parseFloat(val)

  if (val) {
    const result = formatValidVal(
      (isFinancialStatement ? Math.abs(val) : val).toLocaleString(locale, {
        minimumFractionDigits: count,
        maximumFractionDigits: count,
      }),
    )
    return isFinancialStatement && val < 0 ? `(${result})` : result
  }

  if (val === 0) {
    return isFinancialStatement
      ? ZERO_IN_FINANCIAL_STATEMENT
      : formatValidVal(
          val.toLocaleString(locale, {
            minimumFractionDigits: count,
            maximumFractionDigits: count,
          }),
        )
  }

  return EMPTY_VALUE
}

export const formatValWithCurrencyUnit = (
  val,
  exchangeRate = 1,
  multiplier = 1,
) => {
  val = typeof val === 'string' ? parseFloat(val) : val

  if (val) {
    return (val / exchangeRate) * multiplier
  }

  return val
}

export const valToPercent = (
  val,
  locale = DEFAULT_LANGUAGE,
  isResWithout100 = false,
  isFinancialStatement = false,
  count = 2,
  isNotIncludedPercentageIcon = false,
) => {
  if (isInValidValue(val)) {
    return EMPTY_VALUE
  }

  val = typeof val === 'string' ? parseFloat(val) : val
  const realVal = isResWithout100 ? val : val * 100

  return isNotIncludedPercentageIcon
    ? formatVal(realVal, locale, isFinancialStatement, count)
    : formatVal(
        realVal,
        locale,
        isFinancialStatement,
        count,
        (val) => val + '%',
      )
}

export const valDivNumber = (val, number) => {
  const realVal = val / number
  return !isNaN(realVal) ? realVal : EMPTY_VALUE
}

export const isInValidValue = (val) => {
  return val === undefined || val === null
}

export const valByKeyWithDot = (
  data,
  keyWithDot,
  isReturnUndefined = false,
) => {
  const emptyValue = isReturnUndefined ? undefined : EMPTY_VALUE

  if (isInValidValue(data)) {
    return emptyValue
  }

  return keyWithDot.split('.').reduce((result, key) => {
    return isInValidValue(result[key]) ? emptyValue : result[key]
  }, data)
}

export const changeValueWithDot = (value, key, newValue) => {
  const deepCloneValue = JSON.parse(JSON.stringify(value))
  const arrKey = key.split('.')

  return arrKey.reduce((result, key, index) => {
    if (index === arrKey.length - 1) {
      result[key] = newValue
      return deepCloneValue
    }

    if (!result[key]) {
      result[key] = {}
    }
    return result[key]
  }, deepCloneValue)
}

export const formatText = (text) => {
  if (text || text === '') {
    return text
  }

  return EMPTY_VALUE
}

export const isValidNumber = (num) => {
  return num || num === 0
}

export const formatCurrencyFollowLocale = (val, currencyTo, locale) => {
  const newVal = formatVal(
    val,
    locale,
    false,
    currencyTo === CURRENCY.VND ? 0 : 2,
  )

  return locale === languages.en
    ? [currencyTo, newVal].join(' ')
    : [newVal, currencyTo].join(' ')
}

export const formatCurrency = (
  val,
  currencyFrom,
  currencyTo,
  exchangeRates,
  locale,
) => {
  const newExchangeRates = exchangeRates
    .filter((item) => item.currencyCode === currencyFrom)
    .sort((a, b) => a.realYear < b.realYear)

  const exchangeRate = newExchangeRates.length ? newExchangeRates[0] : {}

  return formatCurrencyFollowLocale(
    val * (exchangeRate.lastDayRate || 0),
    currencyTo,
    locale,
  )
}

export const convertData = (
  data,
  getExchangeRate,
  indicatorById = {},
  multiplier,
  exceptKeys = [],
  percentKeys = [],
) => {
  return data.map((item) => {
    const newItem = {}

    Object.keys(item).forEach((key) => {
      if (percentKeys.includes(key)) {
        newItem[key] = item[key] ? item[key] * 100 : item[key]
      } else if (!exceptKeys.includes(key)) {
        const exchangeRate = getExchangeRate({
          year: item.year,
          exchangeRateType: indicatorById[key]?.exchangeRateType,
        })
        newItem[key] = formatValWithCurrencyUnit(
          item[key],
          exchangeRate,
          multiplier,
        )
      } else {
        newItem[key] = item[key]
      }
    })

    return newItem
  })
}
